import { render, staticRenderFns } from "./addNewSignature.vue?vue&type=template&id=beb29602&scoped=true"
import script from "./addNewSignature.vue?vue&type=script&lang=js"
export * from "./addNewSignature.vue?vue&type=script&lang=js"
import style0 from "./addNewSignature.vue?vue&type=style&index=0&id=beb29602&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "beb29602",
  null
  
)

export default component.exports